var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center w-screen h-screen"},[_c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"mb-5 text-9xl"},[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.$t('notfoundpage')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }